import { render, staticRenderFns } from "./License.vue?vue&type=template&id=0f453536&scoped=true&"
import script from "./License.vue?vue&type=script&lang=js&"
export * from "./License.vue?vue&type=script&lang=js&"
import style0 from "./License.vue?vue&type=style&index=0&id=0f453536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f453536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f453536')) {
      api.createRecord('0f453536', component.options)
    } else {
      api.reload('0f453536', component.options)
    }
    module.hot.accept("./License.vue?vue&type=template&id=0f453536&scoped=true&", function () {
      api.rerender('0f453536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/licenses/License.vue"
export default component.exports